<template>
    <div id="search-bar" ref="searchBar">
        <div class="input" @click="() => toggleSearch(true)" :class="{ active: resultActive }">
            <div class="material-icons search-icon">search</div>
            <KeyboardShortcut v-if="selectedSearch">{{ $t(`search.prefix.${selectedSearch}`) }}</KeyboardShortcut>
            <div @click="() => toggleSearch(true)" class="typer-wrapper" v-show="!resultActive" id="typeWriter">
                <vue-typer
                    v-if="!isTherePrefix"
                    :text="$_.shuffle(getTyperSentences)"
                    :repeat="Infinity"
                    :shuffle="false"
                    initial-action="erasing"
                    :pre-type-delay="70"
                    :type-delay="70"
                    :pre-erase-delay="2000"
                    :erase-delay="250"
                    erase-style="select-all"
                    :erase-on-complete="false"
                    caret-animation="blink"
                />
            </div>

            <input ref="searchInput" id="search-bar-input" v-model="searchText" autocomplete="off" />
            <div class="keyboard-shortcut">
                <KeyboardShortcut v-if="!isAnyPrefixTyped">{{ isMacOS ? "⌘" : "CTRL +" }} K</KeyboardShortcut>

                <KeyboardShortcut v-else>
                    {{ $t("search.tapTo", { prefix: capitalizeFirstLetter(searchText) }) }}
                </KeyboardShortcut>
            </div>
        </div>

        <div class="result-search" v-show="resultActive" :class="{ active: resultActive }">
            <div class="empty" v-if="searchText.length <= 0">
                <div class="material-icons search-icon">search</div>
                <div class="info-title">{{ $t("search.searchAreaTitle") }}</div>
                <div class="info-description">
                    {{ $t("search.searchAreaDesc1") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.jump`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.new`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.message`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}

                    <KeyboardShortcut>{{ $t(`search.prefix.chatbot`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.table`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.module`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.dm`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc2") }}
                    <KeyboardShortcut>{{ $t(`search.prefix.visitor`) }}</KeyboardShortcut>
                    {{ $t("search.searchAreaDesc3") }}
                </div>
            </div>
            <div class="items" v-else-if="results.length > 0">
                <div
                    class="item"
                    :id="`item-${index}`"
                    v-for="(item, index) of results"
                    :class="[
                        {
                            active: index === navigationIndex,
                            'centered-name': !item.keywords || item.keywords.length === 0,
                        },
                    ]"
                    @click="action(item)"
                >
                    <KeyboardShortcut>{{ $t(`search.prefix.${item.prefix}`) }}</KeyboardShortcut>
                    <div class="content" :class="{ 'visitor': item.prefix === 'visitor' }"
                         v-if="item.prefix === 'visitor'">
                        <div class="name">{{ getName(item.name) }}</div>
                        <div class="visitor-details">
                            <div class="visitor-details-item">
                                <PlatformIcon :platform="item.payload.platformIcon" :size="18" />
                                {{ item.payload.channelName }}
                            </div>
                            <div class="visitor-details-item">
                                <AgentAvatar :userID="item.payload.ownerId" :size="18" />
                                {{ item.payload.ownerName }}
                            </div>
                        </div>
                    </div>
                    <div class="content" v-else>
                        <div class="name">{{ getName(item.name) }}</div>
                        <div class="keywords">
                            <div v-for="keyword of (item.keywords || []).slice(0, 2)" style="font-weight: bold">
                                {{ keyword }}
                            </div>
                            <div v-for="keyword of (item.keywords || []).slice(2, 6)">
                                {{ keyword }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="empty" v-else>
                <div class="material-icons search-icon" v-if="selectedSearch === 'message'">search</div>
                <div class="material-icons search-icon" v-else>sentiment_dissatisfied</div>
                <div class="message-search-info" v-if="selectedSearch === 'message'">
                    {{ searchText }} ifadesini mesajlarda aramak için
                    <KeyboardShortcut>ENTER</KeyboardShortcut>
                    tuşuna
                    basınız
                </div>
                <div class="info-title" v-else>Not Found Anything</div>
            </div>
            <div class="result-bottom">
                <KeyboardShortcut>
                    <div class="material-icons keyboard-icon">keyboard_arrow_up</div>
                </KeyboardShortcut>
                <KeyboardShortcut>
                    <div class="material-icons keyboard-icon">keyboard_arrow_down</div>
                </KeyboardShortcut>
                <div class="text">{{ $t("search.navigateBtn") }}</div>
                <KeyboardShortcut>
                    <div class="material-icons keyboard-icon">keyboard_return</div>
                </KeyboardShortcut>
                <div class="text">{{ $t("search.selectBtn") }}</div>
                <KeyboardShortcut>ESC</KeyboardShortcut>
                <div class="text">{{ $t("search.cancelBtn") }}</div>
            </div>
            <!-- <div class="search-item">asd</div> -->
        </div>
        <a-modal
            v-if="openRespresentativeOptions"
            class="representativeSettings"
            :destroyOnClose="true"
            :footer="null"
            :title="$t('message.represantativeSettings')"
            :visible="true"
            :width="700"
            style="top: 20px"
            @cancel="() => (openRespresentativeOptions = false)"
        >
            <RepresentativeSettings :is-target-notification="openRespresentativeOptions" />
        </a-modal>
        <a-modal
            title="Message Search"
            :footer="null"
            :width="800"
            :visible="messageSearchOpen"
            @ok="() => (messageSearchOpen = false)"
            @cancel="closeMessageSearchModalViaButton"
            class="message-search-modal-index"
            style="z-index: 1000"
        >
            <MessageSearch :default-query="messageSearchQuery" />
        </a-modal>
    </div>
</template>
<script>
import KeyboardShortcut from "./KeyboardShortcut.vue";
import { searchVisitor } from "../../api/visitor";
import staticSearchElements from "./staticSearchElements.js";
import { mapActions, mapState } from "vuex";
import Fuse from "fuse.js";
import { filter } from "rxjs/operators";
import SYSTEM_PUBSUB, { systemMessageStream } from "../../utils/systemPubSub";
import { maskContactInfo, isMaskContactInfo } from "../../utils/utils";
import RepresentativeSettings from "../RepresentativeSettings.vue";
import MessageSearch from "./MessageSearch.vue";
import PlatformIcon from "../popup-chat/chat-window/ChatMessageArea/components/PlatformIcon.vue";
import AgentAvatar from "../common/AgentAvatar.vue";

export default {
    components: {
        AgentAvatar,
        PlatformIcon,
        RepresentativeSettings,
        KeyboardShortcut,
        MessageSearch,
    },
    data: () => {
        return {
            searchText: "",
            resultActive: false,
            results: [
                {
                    type: "visitor",
                    action: "model-visitor",
                    target: "id",
                    name: "Mehmet",
                },
                {
                    type: "jump",
                    action: "navigator",
                    target: "/mail",
                    name: "Mail",
                },
                {
                    type: "new",
                    action: "navigator",
                    target: "/mail",
                    name: "Send Mail",
                },
                {
                    type: "dm",
                    action: "model-user",
                    target: "id",
                    name: "Mehmet",
                },
            ],
            isMacOS: false,
            navigationIndex: 0,
            selectedSearch: null,
            debounce: null,
            listeners: [],
            isTherePrefix: false,
            typerSentences: {
                en: [
                    "New ⇥ Users",
                    "New ⇥ Tags",
                    "New ⇥ Role",
                    "New ⇥ Triggers",
                    "New ⇥ Department",
                    "New ⇥ Ticket",
                    "Jump ⇥ Settings",
                    "Jump ⇥ Integrations",
                    "Jump ⇥ Team",
                    "Jump ⇥ Users",
                    "Jump ⇥ Report",
                    "Chatbot ⇥ Sales Bot",
                    "Automation ⇥ Sales Automation",
                    "Table ⇥ Sales Table",
                    "Module ⇥ Sales Module",
                    "Message ⇥ Search any message",
                    "DM ⇥ John",
                    "Timing Settings",
                    "visitor@mail.com",
                    "Language and Region",
                    "Theme",
                    "Appearance",
                ],
                tr: [
                    "Yeni ⇥ Kullanıcı",
                    "Yeni ⇥ Etiket",
                    "Yeni ⇥ Rol",
                    "Yeni ⇥ Tetikleyici",
                    "Yeni ⇥ Departman",
                    "Yeni ⇥ Etiketler",
                    "Git ⇥ Ayarlar",
                    "Git ⇥ Entegrasyonlar",
                    "Git ⇥ Takım",
                    "Git ⇥ Kullanıcılar",
                    "Git ⇥ Rapor",
                    "DM ⇥ Enes",
                    "Mesaj ⇥ Mesaj Ara",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyonu",
                    "Table ⇥ Satış Tablosu",
                    "Module ⇥ Satış Modülü",
                    "Zamanlama ayarları",
                    "Ziyaretçi@mail.com",
                    "Dil ve Bölge",
                    "Tema",
                    "Görünüş - Görünüm",
                ],
                ru: [
                    "Новые ⇥ пользователи",
                    "Новые ⇥ метки",
                    "Новые ⇥ роли",
                    "Новые ⇥ триггеры",
                    "Новый ⇥ отдел",
                    "Новый ⇥ билет",
                    "Перейти ⇥ Настройки",
                    "Перейти ⇥ Интеграции",
                    "Перейти ⇥ Команда",
                    "Перейти ⇥ Пользователи",
                    "Перейти ⇥ Отчет",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyонu",
                    "Table ⇥ Satıш Tablosу",
                    "Module ⇥ Satıш Modüлü",
                    "DM ⇥ John",
                    "Настройки тайминга",
                    "visitor@mail.com",
                    "Язык и регион",
                    "Тема",
                    "Внешний вид",
                ],
                de: [
                    "Neue ⇥ Benutzer",
                    "Neue ⇥ Tags",
                    "Neue ⇥ Rolle",
                    "Neu ⇥ Auslöser",
                    "Neue ⇥ Abteilung",
                    "Neues ⇥ Ticket",
                    "Springen ⇥ Einstellungen",
                    "Springen ⇥ Integrationen",
                    "Springen ⇥ Team",
                    "Springen ⇥ Benutzer",
                    "Springen ⇥ Bericht",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyonu",
                    "Table ⇥ Satış Tablosu",
                    "Module ⇥ Satış Modülü",
                    "DM ⇥ John",
                    "Timing-Einstellungen",
                    "visitor@mail.com",
                    "Sprache und Region",
                    "Thema",
                    "Erscheinungsbild",
                ],
                fr: [
                    "Nouveau ⇥ Utilisateurs",
                    "Nouveau ⇥ Tags",
                    "Nouveau ⇥ Rôle",
                    "Nouveau ⇥ Déclencheurs",
                    "Nouveau ⇥ Département",
                    "Nouveau ⇥ Ticket",
                    "Sauter ⇥ Paramètres",
                    "Sauter ⇥ Intégrations",
                    "Sauter ⇥ Équipe",
                    "Sauter ⇥ Utilisateurs",
                    "Sauter ⇥ Rapport",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyonu",
                    "Table ⇥ Satış Tablosu",
                    "Module ⇥ Satış Modülü",
                    "DM ⇥ John",
                    "Paramètres de chronométrage",
                    "visitor@mail.com",
                    "Langue et région",
                    "Thème",
                    "Apparence",
                ],
                es: [
                    "Nuevos ⇥ Usuarios",
                    "Nuevo ⇥ Etiquetas",
                    "Nuevo ⇥ Rol",
                    "Nuevo ⇥ Activadores",
                    "Nuevo ⇥ Departamento",
                    "Nuevo ⇥ Ticket",
                    "Saltar ⇥ Ajustes",
                    "Saltar ⇥ Integraciones",
                    "Saltar ⇥ Equipo",
                    "Saltar ⇥ Usuarios",
                    "Saltar ⇥ Informe",
                    "DM ⇥ Juan",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyonu",
                    "Table ⇥ Satış Tablosu",
                    "Module ⇥ Satış Modülü",
                    "Ajustes de tiempo",
                    "visitor@mail.com",
                    "Idioma y región",
                    "Tema",
                    "Aspecto",
                ],
                ar: [
                    "جديد ⇥ المستخدمون",
                    "جديد ⇥ العلامات",
                    "جديد ⇥ دور",
                    "جديد ⇥ المشغلات",
                    "جديد ⇥ قسم",
                    "جديد ⇥ تذكرة",
                    "قفزة ⇥ إعدادات",
                    "الانتقال ⇥ التكامل",
                    "الانتقال ⇥ فريق",
                    "الانتقال ⇥ المستخدمون",
                    "الانتقال ⇥ تقرير",
                    "DM ⇥ جون",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyonu",
                    "Table ⇥ Satış Tablosu",
                    "Module ⇥ Satış Modülü",
                    "إعدادات التوقيت",
                    "visitor@mail.com",
                    "اللغة والمنطقة",
                    "السمة",
                    "المظهر",
                ],
                it: [
                    "Nuovi ⇥ Utenti",
                    "Nuovi ⇥ Tag",
                    "Nuovo ⇥ Ruolo",
                    "Nuovi ⇥ Trigger",
                    "Nuovo ⇥ Dipartimento",
                    "Nuovo ⇥ Biglietto",
                    "Salta ⇥ Impostazioni",
                    "Salta ⇥ Integrazioni",
                    "Salta ⇥ Team",
                    "Salta ⇥ Utenti",
                    "Salta ⇥ Rapporto",
                    "DM ⇥ Giovanni",
                    "Impostazioni di cronometraggio",
                    "Chatbot ⇥ Satış Botu",
                    "Automation ⇥ Satış Otomasyonu",
                    "Table ⇥ Satış Tablosu",
                    "Module ⇥ Satış Modülü",
                    "visitor@mail.com",
                    "Lingua e regione",
                    "Tema",
                    "Aspetto",
                ],
            },
            isAnyPrefixTyped: false,
            openRespresentativeOptions: false,
            messageSearchOpen: false,
            messageSearchQuery: "",
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels,
            customerWebhook: (state) => state.customerWebhook.allWebHooks,
            users: (state) => state.user.users.data,
            automations: (state) => state.automation.automations,
            tables: (state) => state.table.tables,
            modules: (state) => state.module.modules,
            chatbots: (state) => state.CB.stories,
        }),
        getTyperSentences() {
            const lang = this.$i18n.locale === "en" || this.$i18n.locale === "tr" ? this.$i18n.locale : "en";
            return this.typerSentences[lang];
        },
    },
    methods: {
        ...mapActions({
            setVisitorDetailPopup: "app/setVisitorDetailPopup",
            addNewWindow: "app/addNewWindow",
        }),
        capitalizeFirstLetter(text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        },
        startDM(id) {
            this.$router.push("/chat?tab=teamChat");
            setTimeout(() => {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.START_AGENT_CHAT, { userId: id });
            }, 500);
        },

        getName(name) {
            const result = typeof name == "string" ? name : name[0]; /*Array.isArray(name) ? name[0] : name;*/
            return result;
        },
        toggleSearch(val) {
            console.log("toggleSearch", {
                messageSearchOpen: this.messageSearchOpen,
            });
            if (this.messageSearchOpen) return;
            this.resultActive = val === false || val === true ? val : !this.resultActive;
        },
        action(item) {
            console.log("action", {
                item,
            });
            var matchingKeyword = (item.keywords && item.keywords.length > 0) ? item.keywords[0] : null;
            item.action();
            if (matchingKeyword) {
                this.focusOnElement(matchingKeyword);
            }
            this.clear();
            this.resultActive = false;
        },
        clear() {
            console.log("clear", {
                messageSearchOpen: this.messageSearchOpen,
            });
            this.navigationIndex = 0;
            this.selectedSearch = null;
            this.searchText = "";
        },
        closeMessageSearchModalViaButton(source) {
            this.messageSearchOpen = false;
        },
        onKeyboardShortcut() {
            console.log("onKeyboardShortcut", {
                searchInput: document.getElementById("search-bar-input"),
            });
            this.isMacOS = !navigator.userAgent.includes("Windows");

            const clickListener = (e) => {
                const searchBar = this.$refs.searchBar;
                const typeWriterEl = document.getElementById("typeWriter");
                if (!searchBar?.contains(e.target) && !typeWriterEl?.contains(e.target)) this.toggleSearch(false);
            };
            document.addEventListener("click", clickListener);

            const documentKeyDownFn = (event) => {
                if (event.key === "Escape") {
                    console.log("Escape received");
                    if (this.messageSearchOpen) return;
                    if (!this.selectedSearch) this.toggleSearch(false);
                    this.clear();
                } else if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
                    event.preventDefault();
                    const searchInput = document.getElementById("search-bar-input");
                    if (this.resultActive === false) searchInput?.focus();
                    this.toggleSearch();
                    this.clear();
                }
            };
            const inputKeydownFn = (event) => {
                console.log(
                    `inputKeydownFn key: ${event.key} selectedSearch: ${this.selectedSearch} searchText: ${this.searchText}`,
                );
                if (event.key === "Enter" && this.selectedSearch === "message") {
                    this.messageSearchQuery = this.searchText;
                    this.messageSearchOpen = true;
                    this.toggleSearch(false);
                } else if (event.key === "ArrowUp") {
                    event.preventDefault();
                    this.navigationIndex =
                        this.navigationIndex === 0 ? this.results.length - 1 : this.navigationIndex - 1;
                    const item = document.getElementById(`item-${this.navigationIndex}`);
                    item?.scrollIntoViewIfNeeded({ block: "start", behavior: "smooth", inline: "nearest" });
                    event.stopPropagation();
                } else if (event.key === "ArrowDown") {
                    event.preventDefault();
                    this.navigationIndex =
                        this.navigationIndex === this.results.length - 1 ? 0 : this.navigationIndex + 1;
                    const item = document.getElementById(`item-${this.navigationIndex}`);
                    item?.scrollIntoView({ block: "end", behavior: "smooth", inline: "nearest" });
                    event.stopPropagation();
                } else if (event.key === "Enter") {
                    const item = document.getElementById(`item-${this.navigationIndex}`);
                    item?.click();
                } else if (event.key === "Tab") {
                    event.preventDefault();
                    let prefix = this.searchText.trim().toLowerCase();
                    let prefixies = {
                        new: this.$t("search.prefix.new").toLowerCase(),
                        jump: this.$t("search.prefix.jump").toLowerCase(),
                        visitor: this.$t("search.prefix.visitor").toLowerCase(),
                        dm: "dm".toLowerCase(),
                        chatbot: this.$t("search.prefix.chatbot").toLowerCase(),
                        automation: this.$t("search.prefix.automation").toLowerCase(),
                        table: this.$t("search.prefix.table").toLowerCase(),
                        module: this.$t("search.prefix.module").toLowerCase(),
                        message: this.$t("search.prefix.message").toLowerCase(),
                    };

                    const prefixKeys = {
                        [prefixies.new]: "new",
                        [prefixies.jump]: "jump",
                        [prefixies.visitor]: "visitor",
                        [prefixies.dm]: "dm",
                        [prefixies.chatbot]: "chatbot",
                        [prefixies.automation]: "automation",
                        [prefixies.table]: "table",
                        [prefixies.module]: "module",
                        [prefixies.message]: "message",
                    };
                    if (Object.values(prefixies).includes(prefix) && this.resultActive) {
                        this.selectedSearch = prefixKeys[prefix];
                        this.searchText = "";
                        this.isTherePrefix = true;
                    }
                } else if (event.key === "Backspace" && !this.searchText.length) {
                    this.selectedSearch = null;
                    this.isTherePrefix = false;
                }
            };
            const searchInput = document.getElementById("search-bar-input");
            document.addEventListener("keydown", documentKeyDownFn);
            searchInput?.addEventListener("keydown", inputKeydownFn);
            this.listeners.push(() => {
                document.removeEventListener("click", clickListener);
                document.removeEventListener("keydown", documentKeyDownFn);
                searchInput?.removeEventListener("keydown", inputKeydownFn);
            });
        },
        beforeDestroy() {
            this.listeners.map((cancels) => cancels());
            this.notification.unsubscribe();
        },
        focusOnElement(keyword) {
            var attemptCount = 0;
            var maxAttempts = 5;
            var tryFocus = function () {
                attemptCount++;
                var selectors = [
                    ".feature-title",
                    ".title",
                    ".page-header .title",
                    "label",
                    "h3",
                    "h4",
                    ".ant-card-head-title",
                    ".setting-title",
                    ".ant-collapse-header",
                ];
                var allElements = document.querySelectorAll(selectors.join(", "));
                for (var i = 0; i < allElements.length; i++) {
                    var el = allElements[i];
                    var text = (el.textContent || "").trim();
                    if (text && text.toLowerCase().includes(keyword.toLowerCase())) {
                        var targetEl = el.closest(".feature") || el.closest(".ant-card") || el.closest(".ant-collapse-item") || el.closest("section") || el;
                        targetEl.scrollIntoView({ behavior: "smooth", block: "center" });
                        targetEl.classList.add("search-focus-highlight");
                        setTimeout(function () {
                            targetEl.classList.remove("search-focus-highlight");
                        }, 3000);
                        return;
                    }
                }
                if (attemptCount < maxAttempts) {
                    setTimeout(tryFocus, 500);
                }
            };
            setTimeout(tryFocus, 600);
        },
        createTask() {
            this.addNewWindow({
                type: "chat-create-task",
                title: this.$t("task.createTaskMessage"),
            });
        },
        searchItems() {
            const staticItems = staticSearchElements(this);
            const channelItems = this.channels.reduce((acc, channel) => {
                if (["whatsapp-qr", "whatsapp-v2","whatsapp-unipile", "whatsapp-business-api", "whatsapp-business-api-supsis"].includes(channel.type)) {
                    acc.push({
                        prefix: "jump",
                        type: "navigator",
                        action: () =>
                            this.$router.push(
                                channel.type === "whatsapp-qr"
                                    ? `/integrations/whatsapp-v1/${channel._id}/detail`
                                    : channel.type === "whatsapp-v2"
                                        ? `/integrations/whatsapp-v2/${channel._id}/detail`
                                        : channel.type === "whatsapp-business-api"
                                            ? `/integrations/whatsapp-business-api/${channel._id}/detail`
                                            : channel.type === "whatsapp-unipile"
                                                ? `/integrations/whatsapp-v3/${channel._id}/detail`
                                                : channel.type === "whatsapp-business-api-supsis"
                                                    ? `/integrations/waba/${channel._id}/detail`
                                                    : "/",
                            ),
                        name:
                            channel.type === "whatsapp-qr"
                                ? `Integration Whatsapp QR - Channel Detail (${channel.name})`
                                : channel.type === "whatsapp-v2"
                                    ? `Integration Whatsapp V2 - Channel Detail (${channel.name})`
                                    : channel.type === "whatsapp-business-api"
                                        ? `Integration Business API - Channel Detail (${channel.name})`
                                        : channel.type === "whatsapp-unipile"
                                            ? `Integration Whatsapp V3 - Channel Detail (${channel.name})`
                                            : channel.type === "whatsapp-business-api-supsis"
                                                ? `Integration Business API V2 - Channel Detail (${channel.name})`
                                                : "/",
                    });
                }
                return acc;
            }, []);

            const usersList = this.users.reduce((acc, user) => {
                acc.push({
                    prefix: "dm",
                    type: "navigator",
                    action: () => this.startDM(user._id),
                    name: `${user.name}`,
                });

                return acc;
            }, []);

            const automationItems = this.automations.map((automation) => {
                return {
                    prefix: "automation",
                    type: "navigator",
                    action: () => this.$router.push(`/automations/${automation._id}/design`),
                    name: automation.name,
                };
            });

            const tableItems = this.tables.map((table) => {
                return {
                    prefix: "table",
                    type: "navigator",
                    action: () => this.$router.push(`/tables/t/${table._id}`),
                    name: table.name,
                };
            });

            const moduleItems = this.modules.map((module) => {
                return {
                    prefix: "module",
                    type: "navigator",
                    action: () => this.$router.push(`/module/${module.moduleName}`),
                    name: module.displayName,
                };
            });

            const chatbotItems = this.chatbots.map((chatbot) => {
                const lastVersionDetail = (chatbot?.meta?.versions || []).reverse()[0];
                const version = _.get(lastVersionDetail, "version", "v1.0");

                return {
                    prefix: "chatbot",
                    type: "navigator",
                    action: () => this.$router.push(`/chatbot/story/${chatbot._id}/${version}`),
                    name: chatbot.title,
                };
            });

            return [
                {
                    prefix: "new",
                    type: "navigator",
                    action: () => this.createTask(),
                    name: this.$t("message.createTask"),
                },
                ...channelItems,
                ...staticItems,
                ...usersList,
                ...automationItems,
                ...tableItems,
                ...moduleItems,
                ...chatbotItems,
            ];
        },
    },
    async mounted() {
        this.notification = systemMessageStream
            .pipe(filter((x) => x.type === SYSTEM_PUBSUB.MESSAGE_TYPES.NOTIFICATION_SETTINGS))
            .subscribe(() => {
                this.openRespresentativeOptions = true;
                console.log("Pubsub is working");
            });
    },
    created() {
        this.$nextTick(() => {
            this.onKeyboardShortcut();
        });
    },
    watch: {
        messageSearchOpen(isOpen) {
            if (!isOpen) {
                console.log("messageSearchOpen change", {
                    messageSearchOpen: isOpen,
                });
                this.clear();
                this.toggleSearch(false);
                this.setVisitorDetailPopup(null);
                this.selectedSearch = null;
            }
        },
        searchText(val) {
            let prefixies = {
                new: this.$t("search.prefix.new").toLowerCase(),
                jump: this.$t("search.prefix.jump").toLowerCase(),
                visitor: this.$t("search.prefix.visitor").toLowerCase(),
                dm: "dm".toLowerCase(),
                chatbot: this.$t("search.prefix.chatbot").toLowerCase(),
                automation: this.$t("search.prefix.automation").toLowerCase(),
                table: this.$t("search.prefix.table").toLowerCase(),
                module: this.$t("search.prefix.module").toLowerCase(),
                message: this.$t("search.prefix.message").toLowerCase(),
            };
            console.log("searchText", {
                val,
                resultActiv: this.resultActive,
                selectedSearch: this.selectedSearch,
                prefixies,
                x: Object.keys(prefixies).includes(this.selectedSearch),
            });
            if (val !== "" && !this.resultActive) this.toggleSearch();
            if (this.debounce) clearTimeout(this.debounce);
            let results = [];
            if (this.selectedSearch !== "visitor") {
                let items = this.searchItems();
                if (this.selectedSearch) items = items.filter((item) => item.prefix === this.selectedSearch);
                items = new Fuse(items, { includeScore: true, keys: ["name", ["prefix", "name"], "keywords"] });
                items = items.search(val).map((x) => x.item);
                results = items.map((item) => {
                    if (item.keywords) {
                        const fuse = new Fuse(item.keywords, { includeScore: true });
                        item.keywords = fuse.search(val).map((x) => x.item);
                    }
                    return item;
                });
            }

            const usersHashMap = this.users.reduce((acc, user) => {
                acc[user._id] = user.name;
                return acc;
            }, {});

            const channelsHashMap = this.channels.reduce((acc, channel) => {
                acc[channel._id] = {
                    type: channel.type,
                    name: channel.name,
                };
                return acc;
            }, {});

            this.debounce = setTimeout(() => {
                this.navigationIndex = 0;
                if (this.selectedSearch === "visitor" && val.trim().length >= 3) {
                    searchVisitor(val).then((res) => {
                        this.results = [
                            ...results,
                            ...res.map((v) => {
                                const ownerName = _.get(usersHashMap, v.owner, "N/A");
                                const channelName = _.get(channelsHashMap, `${v.channel}.name`, v.channel ? 'Deleted Channel' : 'Web')
                                const channelType = _.get(channelsHashMap, `${v.channel}.type`, "N/A");
                                const platformIcon = v.channel ? channelType || "notWp" : "";
                                return {
                                    prefix: "visitor",
                                    type: "navigator",
                                    action: () => this.setVisitorDetailPopup(v._id),
                                    name: `${v.fullname || "N/A"} - ${isMaskContactInfo('email') ? maskContactInfo(v.email) : (v.email || "N/A")}`,
                                    payload: {
                                        ownerId: v.owner,
                                        ownerName,
                                        channelName,
                                        platformIcon,
                                    },
                                };
                            }),
                        ];
                    });
                }
            }, 750);
            this.results = results;

            if (Object.values(prefixies).includes(val.trim().toLowerCase())) {
                this.isAnyPrefixTyped = true;
            } else {
                this.isAnyPrefixTyped = false;
            }
        },
        resultActive(newVal, oldVal) {
            if (this.messageSearchOpen) return;
            const searchInput = document.getElementById("search-bar-input");
            if (newVal === false) {
                this.searchText = "";
                searchInput?.blur();
            } else {
                searchInput?.focus();
            }
        },
    },
};
</script>
<style lang="scss">
.message-search-modal-index {
    .ant-modal-mask {
        z-index: 1000 !important;
    }

    .ant-modal-wrap {
        z-index: 1000 !important;
    }
}
.representativeSettings {
    .ant-modal-body {
        padding: 24px 5px 24px 0px;
    }
}

.centered-name {
    align-items: center !important;
}

#search-bar {
    position: relative;
    z-index: 999;

    .typer-wrapper {
        position: absolute;
        /* left: 20px; */
        width: calc(100% - 49px);
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 32px;

        .vue-typer .custom.char.typed {
            color: var(--color-text-low-default);
            font-size: 13px;
        }
    }

    .input {
        position: relative;
        display: flex;
        align-items: center;
        border: 1px solid var(--color-border-default);
        width: 400px;
        height: 32px;
        border-radius: 5px;
        z-index: 1;
        background: var(--color-bg-neutral-default) !important;
        transition: all 0.5s;

        input {
            background: var(--color-bg-neutral-default) !important;
            color: var(--default-text-color) !important;
            font-size: 13px;
        }

        .material-icons {
            color: var(--default-text-color) !important;
            font-size: 18px;
        }

        &.active {
            width: 500px;
        }

        & input {
            border: none;
            outline: none;
            border-radius: 50px;
            //padding: 8px;
            width: 100%;
        }

        .search-icon {
            margin-left: 8px;
        }

        .keyboard-shortcut {
            min-width: max-content;
            margin-right: 8px;
        }
    }

    .result-search {
        display: none;

        .items {
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: flex-start;
            width: 100%;
            max-height: 40vh;
            overflow: auto;

            .item {
                width: 100%;
                display: flex;
                padding-left: 8px;
                padding: 8px;
                font-family: Roboto, "Noto Sans", -apple-system, BlinkMacSystemFont, sans-serif !important;
                color: var(--default-text-color) !important;

                &.active {
                    background: var(--color-bg-neutral-hover);
                }

                &:hover {
                    background: var(--color-bg-neutral-hover);
                }

                .badget {
                    border-radius: 100%;
                    width: 28px;
                }

                .content {
                    background: transparent !important;
                    margin-left: 4px;

                    &.visitor {
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        justify-content: center;

                       .visitor-details {
                           display: flex;
                           align-items: center;
                           gap: 8px;
                           &-item {
                               display: flex;
                               align-items: center;
                               gap: 4px;
                               font-size: 11px;
                           }
                       }
                    }

                    .name {
                        font-weight: bold;
                        font-size: 12px;
                        line-height: 10px;
                    }

                    .keywords {
                        display: flex;
                        flex-direction: column;
                        flex-wrap: nowrap;
                        line-height: 8px;
                        font-size: 9px;

                        .matched {
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        &.active {
            border-radius: 5px;
            position: absolute;
            background: var(--color-bg-neutral-default) !important;
            color: var(--default-text-color) !important;
            width: 100%;
            border: 1px solid var(--color-border-default);
            z-index: 0;
            display: flex !important;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding-top: 7px;
            margin-top: -8px;
            height: max-content;
        }

        .empty {
            padding-top: 40px;
            padding-bottom: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            font-family: Roboto, "Noto Sans", -apple-system, BlinkMacSystemFont, sans-serif !important;
            color: var(--default-text-color) !important;

            .message-search-info {
                font-size: 16px;
                font-weight: bold;
                display: flex;
                justify-content: center;
                align-items: center;
                align-items: center;
                text-align: justify;
                /* padding: 10px; */
                padding: 8px;
                gap: 4px;
                display: flex;
                flex-direction: column;
            }

            .search-icon {
                font-size: 40px;
            }

            .info-title {
                font-size: 16px;
                font-weight: bold;
            }

            .info-description {
                font-size: 12px;
                margin-top: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;

                #keyboard-shortcut {
                    margin: 0 2px;
                }
            }
        }

        .result-bottom {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            border-top: 1px solid var(--color-border-default);
            padding: 2px;
            width: 100%;

            .text {
                margin: 0 2px;
                font-size: 11px;
            }

            .material-icons.keyboard-icon {
                font-size: 16px;
            }
        }
    }
}

@keyframes searchFocusPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.6);
    }
    50% {
        box-shadow: 0 0 0 6px rgba(24, 144, 255, 0.2);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
    }
}

.search-focus-highlight {
    animation: searchFocusPulse 1s ease-in-out 3;
    border-radius: 8px;
    background-color: rgba(24, 144, 255, 0.06) !important;
    transition: background-color 0.3s ease;
}
</style>
